<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <!-- <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}"  (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li> -->

    <li class="nav-item" *ngFor="let item of menu['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: this.active_seq == item.seq}"  (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>
<!-- 서브메뉴 탭 구성 //-->

<section class="ahri-section">
  <div id="board-list">
    <div class="inner-wrap">
      <div class="page-title">{{(currMenu$ | async)['page_name']}}</div>

      <div class="mb20">
        <a href="https://www.ahridirectory.org/Search/SearchHome" target="_blank" class="search-btn" type="button">인증서 검색 및 출력</a>
      </div>

      <div class="mb20">
        ※ 연결되는 AHRI 디렉토리 창 상단에 해당 reference number를 입력하시면 인증서 확인 및 출력이 가능합니다.
      </div>

      <!-- 기본게시판 //-->
      <table class="hlist-table hlist-table1">
      <colgroup>
        <col class="col1" style="width:5%" />
        <col class="col2" style="width:15%" />
        <col class="col3" style="width:20%" />
        <col class="col4" style="width:30%" />
        <col class="col5" style="width:30%" />
      </colgroup>

      <thead>
      <tr>
        <th scope="col">번호</th>
        <th scope="col">업체명</th>
        <th scope="col">홈페이지</th>
        <th scope="col">프로그램(인증품목)</th>
        <th scope="col">AHRI Reference Number</th>
      </tr>
      </thead>

      <tbody>
        <ng-container *ngIf="ahriList.length > 0">
          <ng-container *ngFor="let item of ahriList;index as i">
            <tr>
              <td>{{ahriList.length - i}}</td>
              <td>{{item.companyName}}</td>
              <td>
                <a [href]="item.homepage" target="_blank">
                  <ng-container *ngIf="item.url">
                    <img [src]="item.url" [alt]="item.companyName" class="ahri-logo" />
                  </ng-container>
                  <ng-container *ngIf="!item.url">
                    {{item.homepage}}
                  </ng-container>
                </a>
              </td>
              <td>
                {{item.programItem}}
              </td>
              <td>
                {{item.referenceNumber}}
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="ahriList.length < 1">
          <tr>
            <td colspan="5">검색된 AHRI인증 국내인증업체 정보가 없습니다.</td>
          </tr>
        </ng-container>
      </tbody>
      </table>
    </div>
  </div>
</section>

<app-footer></app-footer>